import type { RefObject } from 'react'
import {
  BG,
  SHADE_SIDE,
  SHADE_FRONT,
  SHADE_SLOT,
  BLOCK_OUTLINE,
  FACE_RIGHT,
  FACE_FRONT,
  SLOT,
} from './geometry'

/* =========================================
   BLOCK
   One rigid group that slides along the belt on scroll: the block's
   faces and the slot. The outgoing belt is page-fixed (it ends at the
   fold) and is cut at this block's face by the moving slot clip, which
   the scroll hook translates in lockstep with this group.
   ========================================= */
export function Block({
  groupRef,
}: {
  groupRef: RefObject<SVGGElement | null>
}) {
  return (
    <g ref={groupRef}>
      {/* Silhouette (top face stays light), then the two vertical
          faces shaded since the light comes from above */}
      <path d={BLOCK_OUTLINE} fill={BG} vectorEffect="non-scaling-stroke" />
      <path d={FACE_RIGHT} fill={SHADE_SIDE} vectorEffect="non-scaling-stroke" />
      <path d={FACE_FRONT} fill={SHADE_FRONT} vectorEffect="non-scaling-stroke" />

      {/* Slot where the belt exits — dark: you're looking into the
          block. The exiting belt covers most of it; the sliver left
          of the belt reads as the opening's shadow. */}
      <path d={SLOT} fill={SHADE_SLOT} vectorEffect="non-scaling-stroke" />
    </g>
  )
}
